<script lang="ts">
	import { browser } from '$app/environment'
	import { MediaType } from '$lib/graphql/enums'
	import { constructCdnUrl, constructVideoThumbnailUrl } from '$lib/utils/cloudflare-loader'
	import { createImageErrorHandler } from '$lib/utils/image-error-handler'

	interface Props {
		mediaType: MediaType
		cloudflareID: string
		animationDelay?: number
		animationDuration?: number
		isLoaded?: boolean
		onload?: () => void
	}

	let {
		mediaType,
		cloudflareID,
		animationDelay = 0,
		animationDuration = 200,
		isLoaded = false,
		onload,
	}: Props = $props()

	let imageLoaded = $state(false)

	function handleImageLoad() {
		imageLoaded = true
		onload?.()
	}

	// Create error handlers for different media types
	const imageErrorHandler = $derived(
		createImageErrorHandler(mediaType === MediaType.Image ? cloudflareID : null, 'GENERAL', 2, () =>
			console.warn('Image failed to load after retries:', cloudflareID),
		),
	)

	const videoErrorHandler = $derived(
		createImageErrorHandler(mediaType === MediaType.Video ? cloudflareID : null, 'GENERAL', 2, () =>
			console.warn('Video thumbnail failed to load after retries:', cloudflareID),
		),
	)
</script>

<div class="grid grid-cols-[100%]">
	<div class="z-20 flex-col area">
		{#if mediaType === MediaType.Image}
			<img
				class="h-[200px] w-[140px] rounded-lg object-cover border-2 border-transparent transition-opacity duration-200"
				style={`opacity: ${imageLoaded ? 1 : 0}; transition-delay: ${animationDelay}ms;`}
				src={constructCdnUrl(cloudflareID)}
				alt="highlight"
				onload={handleImageLoad}
				onerror={imageErrorHandler}
			/>
		{:else if mediaType === MediaType.Video}
			<img
				class="h-[200px] w-[140px] rounded-lg object-cover border-2 border-transparent transition-opacity duration-200"
				style={`opacity: ${imageLoaded ? 1 : 0}; transition-delay: ${animationDelay}ms;`}
				src={constructVideoThumbnailUrl(cloudflareID)}
				alt="highlight"
				onload={handleImageLoad}
				onerror={videoErrorHandler}
			/>
		{/if}
	</div>
	<div
		class="z-10 flex-col area transition-opacity duration-200"
		style={`opacity: ${imageLoaded ? 0 : 1}; transition-delay: ${animationDelay}ms;`}
	>
		<div class="h-[200px] w-[140px] rounded-lg bg-brand-gray-4/20 animate-pulse"></div>
	</div>
</div>

<style lang="postcss">
	.area {
		grid-area: 1 / 1 / 2 / 2;
	}
</style>
